import { pipelineNotificationApi } from '@/modules/pipelines/api';
import { EntityNode } from '@/modules/pipelines/model/pipeline-alerts/entity-node';

const MAX_DEPTH = 8;

export async function getEntitiesByIds(ids: string[]): Promise<EntityNode[]> {
  const results = await Promise.all(
    ids.map(id => pipelineNotificationApi.getPipelineEntityById(id).catch(() => undefined)),
  );
  return results.filter((node): node is EntityNode => !!node);
}

export async function getOwnsAncestry(entityId: string): Promise<EntityNode[]> {
  const chain: EntityNode[] = [];
  const visited = new Set<string>();
  let currentId: string | undefined = entityId;

  while (currentId && !visited.has(currentId) && chain.length < MAX_DEPTH) {
    visited.add(currentId);

    let node: EntityNode;
    try {
      node = await pipelineNotificationApi.getPipelineEntityById(currentId);
    } catch {
      // A missing ancestor truncates the chain rather than discarding what was resolved:
      // a partial breadcrumb is still more useful than none.
      break;
    }

    chain.unshift(node);
    if (node.type === 'PIPELINE') break;

    currentId = (node.relations ?? []).find(
      relation => relation.type === 'OWNS' && relation.targetId === node._id,
    )?.sourceId;
  }

  return chain;
}
